// storeQuery.ts

// List all stores of a company
export const getCompanyStoresQuery = `
  query ListStores($input: ListStoresInput!) {
    listStores(input: $input) {
        code
        stores {
            id
            companyId
            name
            managerId
            status
            contactEmail
            contactPhone
            address {
                country
                province
                district
                sector
                cell
                village
                streetAddress
            }
        }
    }
  }
`;

// Alias used by the Order module (`useListStores`) — same listStores operation.
export const listStoresQuery = getCompanyStoresQuery;

// Single store by ID (proxy → identity getStoreDetails)
export const getStoreDetailsQuery = `
  query GetStoreDetails($input: GetStoreDetailsInput!) {
    getStoreDetails(input: $input) {
      code
      store {
        id
        companyId
        name
        managerId
        status
        contactEmail
        contactPhone
        address {
          country
          province
          district
          sector
          cell
          village
          streetAddress
        }
      }
    }
  }
`;

// Get a store by ID (through listStoreUsers or related store query)
export const getStoreQuery = `
  query GetStore($input: ListStoresInput!) {
    listStores(input: $input) {
        code
        stores {
            id
            companyId
            name
            status
            managerId
            contactEmail
            contactPhone
            address {
                country
                province
                district
                sector
                cell
                village
                streetAddress
            }
        }
    }
  }
`;

// Update store details
export const updateStoreMutation = `
  mutation UpdateStore($input: UpdateStoreInput!) {
    updateStore(input: $input) {
        code
        store {
            id
            name
            companyId
            status
            managerId
            contactEmail
            contactPhone
            address {
                country
                province
                district
                sector
                cell
                village
                streetAddress
            }
        }
    }
  }
`;

// Update store status
export const updateStoreStatusMutation = `
  mutation UpdateStoreStatus($input: UpdateStoreStatusInput!) {
    updateStoreStatus(input: $input) {
        code
        storeId
        status
    }
  }
`;

// Create a new store
export const createStoreMutation = `
  mutation CreateStore($input: CreateStoreInput!) {
    createStore(input: $input) {
        code
        store {
            id
            companyId
            name
            status
            contactEmail
            contactPhone
            address {
                country
                province
                district
                sector
                cell
                village
                streetAddress
            }
        }
    }
  }
`;

// Assign a store admin
export const assignStoreAdminMutation = `
  mutation AssignStoreAdmin($input: AssignStoreAdminInput!) {
    assignStoreAdmin(input: $input) {
        code
        user {
            id
            firstName
            lastName
            email
            role
            companyId
            storeId
        }
    }
  }
`;

// List all users in a store
export const listStoreUsersQuery = `
  query ListStoreUsers($input: ListStoreUsersInput!) {
    listStoreUsers(input: $input) {
        code
        users {
            id
            firstName
            lastName
            email
            role
            companyId
            storeId
        }
    }
  }
`;

// List users across multiple stores
export const listStoresUsersQuery = `
  query ListStoresUsers($input: ListStoresUsersInput!) {
    listStoresUsers(input: $input) {
        code
        users {
            id
            firstName
            lastName
            email
            role
            companyId
            storeId
        }
    }
  }
`;

// Add supplier to a store
export const addStoreSupplierMutation = `
  mutation AddStoreSupplier($input: AddStoreSupplierInput!) {
    addStoreSupplier(input: $input) {
        id
        companyId
        name
        address {
            country
            province
            district
            sector
            cell
            village
            streetAddress
        }
        status
        supplierIds
    }
  }
`;

// Remove supplier from a store
export const removeStoreSupplierMutation = `
  mutation RemoveStoreSupplier($input: RemoveStoreSupplierInput!) {
    removeStoreSupplier(input: $input) {
        id
        companyId
        name
        address {
            country
            province
            district
            sector
            cell
            village
            streetAddress
        }
        status
        supplierIds
    }
  }
`;

// delete store
export const deleteStoreMutation = `
  mutation DeleteStore($input: DeleteStoreInput!) {
    deleteStore(input: $input) {
        code
    }
  }
`;

// Get a store by ID (through listStoreUsers or related store query)
export const changeStoreManagerQuery = `
  mutation changeStoreManager($input: ChangeStoreManagerInput!) {
    changeStoreManager(input: $input) {
        code
        store {
            id
            companyId
            name
            status
            contactEmail
            contactPhone
            managerId
            address {
                country
                province
                district
                sector
                cell
                village
                streetAddress
            }
        }
    }
  }
`;
